import './styles.scss';

export default {
    name: 'MessagingComposeMessagePage',

    data() {
        return {
            message: ' ',
            isPresetSaved: false,  
            showHint:false

        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_message() {
            return this.$store.state.messaging.message;
        },
        // enable button only when message has 10+ chars
        canSavePreset() {
            return this.message && this.message.trim().length > 10 && !this.isPresetSaved;
        },

        isNewMessage() {
            return this.$store.state.messaging.message_type === 'new';
        }
    },

    created() {
        const back_url = this.$store.state.messaging.message_type !== 'new' ? '/action/emergency-messages/available-messages' : '/action/emergency-messages/choose-message';
        
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: back_url
        });

        this.message = this.stored_message;
        this.isPresetSaved = false;  // reset on page load

    },

    methods: {
        update(message) {
            this.message = message;
            this.$store.commit('setMessage', message);
             this.isPresetSaved = false;  // reset if user edits message after saving

        },

        saveAsPreset() {
            if (!this.canSavePreset) return;

            this.$store.dispatch('createCustomMessage', { message: this.message})
                .then(() => {
                    this.isPresetSaved = true;  // disable button after save
                    this.$ionic.toastController.create({
                        message: 'Message Saved Successfully',
                        duration: 2000,
                        color: 'success',
                        position: 'bottom'
                    }).then(toast => toast.present());
                })
                .catch(() => {
                    this.$ionic.toastController.create({
                        message: 'Failed to save preset message',
                        duration: 2000,
                        color: 'danger',
                        position: 'bottom'
                    }).then(toast => toast.present());
                });
        },

        next() {
            this.$store.commit('setMessage', this.message);
            this.$router.push('/action/emergency-messages/preview');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};